import { Button } from '@/components/ui/button'
import { Dialog } from '@/components/ui/dialog'
import { useTranslation } from 'react-i18next'

interface Props {
  open: boolean
  onClose: () => void
  onConfirm: () => void
  title?: string
  message?: string
  confirmLabel?: string
  cancelLabel?: string
  destructive?: boolean
  loading?: boolean
}

export function ConfirmDialog({
  open,
  onClose,
  onConfirm,
  title,
  message,
  confirmLabel,
  cancelLabel,
  destructive,
  loading,
}: Props) {
  const { t } = useTranslation('common')
  return (
    <Dialog
      open={open}
      onClose={loading ? () => undefined : onClose}
      title={title ?? t('confirmation_required')}
      size="sm"
      footer={
        <>
          <Button variant="outline" onClick={onClose} disabled={loading}>
            {cancelLabel ?? t('cancel')}
          </Button>
          <Button
            variant={destructive ? 'destructive' : 'primary'}
            onClick={onConfirm}
            loading={loading}
          >
            {confirmLabel ?? (destructive ? t('delete') : t('confirm'))}
          </Button>
        </>
      }
    >
      <p className="text-sm text-muted-foreground">
        {message ?? t('this_action_cannot_be_undone')}
      </p>
    </Dialog>
  )
}
